import { Breakpoints } from '@pb/utils'

import { AppState } from './types'

const initalState: AppState = {
  screenSize: Breakpoints.XLARGE,
  isSettingsLoading: false,
  isConfigLoading: false,
  isUserLoading: false,
  isUserLoadingFailed: false,
  isUserRequested: false,
  saveTimestamp: null,
  settings: {},
  config: {},
  showLoaders: false,
  user: {},
  xhrErrorCodes: {},
  featureToggleFlags: { shouldFetchFeatureToggleFlags: false },
  errorModal: {},
  previousFNSubscribeState: false,
  isSendAgainClicked: false,
  isSendAgainAlreadyClicked: false,
  isChallengesBannerTrackingSent: false,
}

export default initalState
